import React, {useEffect, useState} from "react";
import { Button, Row, Col } from 'antd';
import { sendHttpPostRequest } from "../../../api/http-request";
import courseMainStyles from "../course-main.module.less";
import "../course.module.css";
import * as constants from '../../../constants/constants';
import { DownloadOutlined } from '@ant-design/icons';
import slidesStyles from './course-main-teacher-slides.module.less'
import kejianEmpty from "../../../static/image/empty/queshengye-kejian.png";
import slidesStudentStyles from './course-main-student-slides.module.less'
import Cookies from "js-cookie";


import Icon from '@ant-design/icons'


import  {ReactComponent as filepdfSvg }   from '../../../static/image/course/pdf.svg'
import { ReactComponent as filepptSvg }   from '../../../static/image/course/ppt.svg'
import { ReactComponent as filewordSvg }   from '../../../static/image/course/word.svg'
import { ReactComponent as fileexcelSvg }   from '../../../static/image/course/excel.svg'
import { ReactComponent as filecsvSvg }   from '../../../static/image/course/csv.svg'
import { ReactComponent as fileotherSvg }   from '../../../static/image/course/otherfile.svg'

import  {ReactComponent as downloadSvg }   from '../../../static/image/course/download.svg'
const downloadIcon = (props:any) => (<Icon component={downloadSvg} {...props} />)

const filepdfIcon = (props:any) => (<Icon component={filepdfSvg} {...props} />)
const filepptIcon = (props:any) => (<Icon component={filepptSvg} {...props} />)
const filewordIcon = (props:any) => (<Icon component={filewordSvg} {...props} />)
const fileexcelIcon = (props:any) => (<Icon component={fileexcelSvg} {...props} />)
const filecsvIcon = (props:any) => (<Icon component={filecsvSvg} {...props} />)
const fileotherIcon = (props:any) => (<Icon component={fileotherSvg} {...props} />)



export interface Props {
    course_id:any;
}
/** 教师课程主页面 */
export const CourseMainStudentSlides: React.FC<Props> = (props) => {
    const {course_id} = props;
    const [slides, setSlides] = useState([] as any[]);    //课程的课件

    // 点击下载
    const onDownloadSlidesClick = (url:any, event:any) => {
        event.preventDefault();
        window.open(url?.startsWith("http") ? url : constants.BACKEND_URL + url);
    }



    useEffect(()=> {
        querySlides();
  },[])


    const getBackgroundByFileName = (filename:any)=> {
        let suffix = filename.toLowerCase()
        if (suffix.endsWith("ppt") || suffix.endsWith("pptx") ) {
            return "#f57c001a"
        }else if (suffix.endsWith("pdf")){
            return "#d32f2f1a"
        }else if (suffix.endsWith("xls") || suffix.endsWith("xlsx")) {
            return "#388e3c1a"
        }else if (suffix.endsWith("doc") || suffix.endsWith("docx")) {
            return "#1976d21a"
        }else if (suffix.endsWith("csv")) {
            return "#00796b1a"
        }else {
            return "#37474f1a"
        }
        
    }

    const getIconByFileName = (filename:any)=> {
        let suffix = filename.toLowerCase()
        if (suffix.endsWith("ppt") || suffix.endsWith("pptx") ) {
            return filepptIcon
        }else if (suffix.endsWith("pdf")){
            return filepdfIcon
        }else if (suffix.endsWith("xls") || suffix.endsWith("xlsx")) {
            return fileexcelIcon
        }else if (suffix.endsWith("doc") || suffix.endsWith("docx")) {
            return filewordIcon
        }else if (suffix.endsWith("csv")) {
            return filecsvIcon
        }else {
            return fileotherIcon
        }
        
    }


    const querySlides = () => {
        sendHttpPostRequest(
            'course/api/user_query_course_info',
            {
                sessionid: Cookies.get("sessionid"),
                sid: Cookies.get("sessionid"),
                course_id: course_id
            },
            (response: any) => {
                if (response.is_ok) {
                    setSlides(response.query_info.lecture_list);
                }
            }
        )
    }

    return (
    <div >


      <Row align={"middle"} gutter={[24,24]}>
        {
          slides?.map((slide, slideIndex)=>(
            <Col span={8} key={slideIndex}>
              <div className={slidesStyles.slideCard}>
                  <Row wrap={false} align="middle" style={{padding: 16}}>
                    <Col flex="60px">
                      <div>
                        <span className={slidesStyles.fileIconWrapper} style={{background:getBackgroundByFileName(slide?.name)}}>
                          <Icon component={getIconByFileName(slide?.name)}/>
                        </span>

                      </div>
                    </Col>

                    <Col flex="auto">
                      <div className={slidesStyles.slideName}>
                        {slide?.name}
                      </div>
                    </Col>
                  </Row>

                  <Row wrap={false} align="middle" className={slidesStyles.actionDiv}>
                    <Col span={12} style={{textAlign:'left'}}>
                      <div>
 
                        </div>
                    </Col>
                    <Col span={12} style={{textAlign:'right'}}>
                      <div>
                          <span title="下载" className={slidesStyles.actionIconWrapper}
                          
                          onClick={onDownloadSlidesClick.bind(this, slide?.url)}
                           
                          ><Icon component={downloadIcon}/></span>  

                        
                      </div>
                    </Col>
                  </Row>

              </div>
            </Col>
          ))
        }

      </Row>

        {slides.length == 0 && (
            <div style={{ textAlign: 'center', paddingTop: 20 }}>
            <img src={kejianEmpty} width={120} height={120} />
            <div style={{ color: '#999', marginTop: 10 }}>
                老师还没开放任何课件~
            </div>
            </div>
        )}


    </div>
    )

}

export default CourseMainStudentSlides

